export default __webpack_public_path__ + "static/media/Samsung Galaxy A30.4b31fecd.png";